module.exports = __webpack_public_path__ + "img/empty.5fba592b.png";